<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  isConfirmLoading?: boolean;
  remainingSeconds?: number;
  confirm?: () => Promise<unknown>;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  remainingSeconds: 0,
  confirm: undefined,
});

const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  continueBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleContinueClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('continueBtnClick', event, props);
}

function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditLockTimeoutDialog, dialog.dialogRoot]"
    data-testid="jobEditLockTimeoutDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader :show-close-btn="false">
        Session Timeout
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="[dialog.text, $style.text]">
        You've been inactive for a while. To unlock job you will be signed out
        in 2 minutes. Click "Continue editing" to stay signed in.
      </div>
      <div :class="$style.countdown">
        {{ formatTime(props.remainingSeconds) }}
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :disabled="props.isConfirmLoading"
            @click="handleCancelClick"
          >
            Cancel Changes
          </KBtn>
        </li>
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            append-icon="mdi-lock"
            :loading="props.isConfirmLoading"
            @click="handleContinueClick"
          >
            Continue Editing
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
.jobEditLockTimeoutDialog {
}

.text {
  margin: 0 0 1rem 0;
}

.countdown {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin: 1rem 0;
}
</style>
